import { useDispatch, useSelector } from 'react-redux';
import { Dispatch, useEffect } from 'react';

import { KnmCollapse } from '../../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupConditionForm } from '../interfaces/IGroupConditionForm';
import { PassportGroupPassportTypeEnum } from '../enums/PassportGroupPassportTypeEnum';
import { FieldBlock } from '../../../UIPackage/FormModule/components/FieldBlock';
import { SelectInputField } from '../../../UIPackage/MainModule/components/SelectInputField';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { dictionariesTargetEntityItemGet } from '../../../CorePackage/DictionariesModule/actions/dictionariesActions';
import { makeGetDictionariesTargetEntitySelectOptions } from '../../../CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from '../../../CorePackage/MainModule/interfaces/IRootState';
import { Row } from '../../../UIPackage/FormModule/components/Row';
import { DatePickerField } from '../../../UIPackage/MainModule/components/DatePickerField';
import styles from './CommonGroupCondition.module.scss';
import { catalogGet } from '../../../CorePackage/CatalogsModule/actions/catalogsActions';
import { CommonCatalogsNamesEnum } from '../../../CorePackage/CatalogsModule/enums/CommonCatalogsNamesEnum';
import {
  getCatalogsMspCategoriesSelectOptions,
  getCatalogsRegisterTypesSelectOptions,
} from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';

interface ISubjectGroupConditionProps {
  name: string;
  category: IGroupConditionForm['category'];
}

export const SubjectGroupCondition = ({ name, category }: ISubjectGroupConditionProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const subjectTypeSelectOptions = useSelector((state: IRootState) =>
    makeGetDictionariesTargetEntitySelectOptions()(state, undefined),
  )?.filter(item => item.code);
  const regTypeSelectOptions = useSelector(getCatalogsRegisterTypesSelectOptions);
  const mspCategorySelectOptions = useSelector(getCatalogsMspCategoriesSelectOptions);

  useEffect(() => {
    dispatch(dictionariesTargetEntityItemGet());
    dispatch(catalogGet(CommonCatalogsNamesEnum.REGISTER_TYPES));
    dispatch(catalogGet(CommonCatalogsNamesEnum.MSP_CATEGORIES));
  }, [dispatch]);

  if (category === PassportGroupPassportTypeEnum.ERP) {
    return null;
  }

  return (
    <KnmCollapse title="Сведения о контролируемом лице мероприятий">
      <>
        <FieldBlock label="Тип контролируемого лица" margin="bottom">
          <SelectInputField name={`${name}.subjectTypes`} options={subjectTypeSelectOptions} isMulti isClearable />
        </FieldBlock>
        <FieldBlock label="Наличие контролируемого лица в реестрах" margin="bottom">
          <SelectInputField name={`${name}.regTypes`} options={regTypeSelectOptions} isMulti isClearable />
        </FieldBlock>
        <FieldBlock label="Категория субъекта МСП" margin="bottom">
          <SelectInputField name={`${name}.mspCategories`} options={mspCategorySelectOptions} isMulti isClearable />
        </FieldBlock>
        <Row title="Дата регистрации юридического лица в ЕГРЮЛ, ЕГРИП (интервал)" justify="start" align="baseline">
          <DatePickerField name={`${name}.checkResultStartDate`} />
          <span className={styles.DateFieldsSpace}>—</span>
          <DatePickerField name={`${name}.checkResultEndDate`} />
        </Row>
      </>
    </KnmCollapse>
  );
};
